import state from './waste/state'
import mutations from './waste/mutations'
import getters from './waste/getters'
import actions from './waste/actions'

export const constructTimestampKey = dataKey => {
  if (typeof dataKey === 'string') {
    return `${dataKey}Timestamp`
  } else {
    throw new TypeError('datakey can only be of type String')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
